import React from "react";
import { useNavigate } from "react-router-dom";

const NaboraDeals = ({ data }) => {
  const navigate = useNavigate();

  const defaultData = {
    title: "Top Deals Around Your Neighbourhood",
    subtitle:
      "Discover local offers, merchant deals and community rewards powered by Nabora.",

    deals: [
      {
        icon: "🥗",
        category: "Food & FMCG",
        title: "Local Food Festival Offers",
        merchant: "Neighbourhood Food Partners",
        discount: "Up to 30% OFF",
        type: "merchant",
      },
      {
        icon: "👗",
        category: "Fashion",
        title: "Local Fashion Deals",
        merchant: "Lifestyle Brands",
        discount: "Special Exhibition Pricing",
        type: "merchant",
      },
      {
        icon: "🎁",
        category: "Rewards",
        title: "BOS Community Rewards",
        merchant: "Nabora Ecosystem",
        discount: "Earn Reward Points",
        type: "reward",
      },
    ],
  };

  const content = data || defaultData;

  const handleDealAction = (deal) => {
    switch (deal.type) {
      case "merchant":
        navigate("/finditlocal");
        break;

      case "reward":
        navigate("/purpledoor/bos-rewards");
        break;

      default:
        break;
    }
  };

  return (
    <div className="min-h-screen bg-slate-950 text-white">
      <div className="py-8 px-6 bg-gradient-to-br from-violet-950 via-purple-950 to-slate-950">
        <div className="max-w-5xl mx-auto text-center">
          <div className="uppercase tracking-[4px] text-yellow-300 text-sm mb-4">
            ⭐ NABORA DEALS
          </div>

          <h1 className="text-2xl lg:text-4xl font-bold mb-4">
            {content.title}
          </h1>

          <p className="text-slate-300 text-base lg:text-xl max-w-3xl mx-auto">
            {content.subtitle}
          </p>
        </div>
      </div>

      <div className="py-8 px-6">
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {content.deals.map((deal, index) => (
              <div
                key={index}
                className="bg-slate-900/80 rounded-3xl p-6 border border-white/10 hover:border-purple-400/50 transition-all"
              >
                <div className="text-5xl mb-4">{deal.icon}</div>

                <div className="text-xs uppercase tracking-widest text-cyan-300 mb-2">
                  {deal.category}
                </div>

                <h2 className="text-cyan-200 text-lg font-bold mb-3">{deal.title}</h2>

                <div className="space-y-2 text-sm text-slate-300">
                  <div>🏪 {deal.merchant}</div>

                  <div className="text-yellow-300 font-semibold">
                    🎯 {deal.discount}
                  </div>
                </div>

                <button
                  onClick={() => handleDealAction(deal)}
                  className="mt-5 w-full px-4 py-2 rounded-xl bg-gradient-to-r from-fuchsia-500 to-violet-600 font-semibold hover:scale-105 transition-all"
                >
                  Explore Deal →
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="py-8 px-6 bg-gradient-to-br from-slate-900 to-violet-950">
        <div className="max-w-4xl mx-auto text-center">
          <div className="text-5xl mb-4">🛍️</div>

          <h2 className="text-cyan-200 text-xl lg:text-3xl font-bold mb-3">
            Support Local. Save More. Grow Together.
          </h2>

          <p className="text-slate-300 mb-6">
            Nabora connects customers with trusted neighbourhood merchants
            through discovery, rewards and community commerce.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <button
              onClick={() => navigate("/finditlocal")}
              className="px-6 py-3 rounded-xl border border-white/30 hover:bg-white/10 transition-all"
            >
              📍 Find Local Stores
            </button>

            <button
              onClick={() => navigate("/nabora/coupons")}
              className="px-6 py-3 rounded-xl border border-white/30 hover:bg-white/10 transition-all"
            >
              🎟️ View Coupons
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NaboraDeals;
